// removed by extract-text-webpack-plugin
module.exports = {"feetip":"feetip","place-top":"place-top","place-left":"place-left","place-bottom":"place-bottom","clienttip":"clienttip"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/tooltip.css
// module id = 1155
// module chunks = 0